import { TableProps } from 'antd/es/table/InternalTable';
import { User } from 'types/data';

export const UserTableProps: TableProps<User> = {
  bordered: false,
  size: 'large',
  showHeader: true,
  tableLayout: 'auto',
  pagination: false,
  scroll: { x: '100vw' },
  rowSelection: {},
};
